import { Injectable } from '@angular/core';
import { Pejabat } from './pejabat';
import { PEJABAT } from './mock-pejabat';



@Injectable()
export class PejabatService {
  getPejabats(): Promise<Pejabat[]> {
    return Promise.resolve(PEJABAT);
  }
  getPejabat(id: number): Promise<Pejabat> {
    return this.getPejabats().then(PEJABAT => PEJABAT.find(PEJABAT => PEJABAT.id === id));
}

  // See the "Take it slow" appendix
//   getHeroesSlowly(): Promise<Hero[]> {
//     return new Promise(resolve => {
//       // Simulate server latency with 2 second delay
//       setTimeout(() => resolve(this.getHeroes()), 2000);
//     });
//   }
}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/pejabat.service.ts